/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import classes from '@/app/components/brands/BrandsPageBuilderComponent/brandsPageBuilderComponentStyles.module.scss';
import Image from "next/image";
import {useTranslation} from "next-i18next";
import Link from "next/link";
import {BRAND_DETAILS_PAGE_PREFIX, BRAND_DETAILS_PAGE_SUFFIX} from "@/app/config/brandsConfig";
import {TBrandPageBuilderComponentItem} from "@/app/components/brands/BrandsPageBuilderComponent/index";

const BrandsGrid = (props: {
    brands: TBrandPageBuilderComponentItem[],
    className?: string,
}) => {
    const {t} = useTranslation();
    const sortedBrands = props.brands.sort((a, b) => Number(a.sort_order) - Number(b.sort_order));;

    return sortedBrands && sortedBrands.length > 0 ? <div className={classes.grid}>
        {sortedBrands.map((brand) => {
            return <div key={brand?.brand_name} className={classes.brand}>
                <Link href={`/${BRAND_DETAILS_PAGE_PREFIX}/${brand?.url_slug}${BRAND_DETAILS_PAGE_SUFFIX}`} className={classes.brandInner}>
                    {brand?.logo ?
                        <Image
                            src={brand.logo}
                            fill={true}
                            className={classes.img}
                            alt={!!brand?.logo_alt ? brand?.logo_alt : !!brand?.brand_name ? brand?.brand_name : 'Brand'}
                        /> :
                        <div className={classes.noLogo}>{brand?.brand_name}<br/>({t("No logo")})</div>}
                </Link>
            </div>
        })}
    </div> : <></>;
}

export default BrandsGrid;